import { type App, watch } from "vue";
import { useRouter } from "@library/Services";

// Forces the vue-router to scroll to top on page change
export function useScrollTop()
{
    return {
        install: async ( app: App ) =>
        {
            const router = useRouter();
            watch( () => router.current.value.path, () => {
                document.querySelector( '#page-scroll-container')!.scrollTo( 0, 0 );
            });
        }
    };
};